import React from "react";
import { useHistory } from "react-router-dom";
import { Button, Modal } from "react-bootstrap";
import { HelpOutline } from "@material-ui/icons";

function TransactionPrompt({ showTransactionPrompt, cancel }) {
  const history = useHistory();

  return (
    <Modal
      show={showTransactionPrompt}
      onHide={() => cancel()}
      dialogClassName="modal-90w"
      aria-labelledby="example-custom-modal-styling-title"
      className="modal-med modal-400 modal-delete"
      centered
      backdrop={false}
    >
      <Modal.Header closeButton style={{ paddingTop: 0 }} />
      <Modal.Body className="pb-0 text-center">
        <HelpOutline />
        <p className="mt-2">
          Do you want to create a new artwork or create an appointment for an
          existing one or a quick appointment?
        </p>
      </Modal.Body>
      <Modal.Footer>
        <Button
          variant="primary"
          className="btn-blue w-140"
          onClick={() => history.push("/artwork/create")}
        >
          New Artwork
        </Button>
        <Button
          variant="primary"
          className="btn-blue w-140"
          onClick={() => history.push("/artwork/addappointment")}
        >
          Existing Artwork
        </Button>
        <Button
          variant="primary"
          className="btn-blue w-140"
          onClick={() => history.push("/quickAppointment")}
        >
          Quick Appointment
        </Button>
      </Modal.Footer>
    </Modal>
  );
}

export default TransactionPrompt;
